export const categories = [
  {
    slug: 'wanghong-heliao',
    name: '网红黑料',
    description: '聚焦各大平台网红达人的最新爆料、翻车实录与人设崩塌全记录，第一时间追踪网红圈的猛料动态。',
    icon: 'ri-user-search-line',
    color: 'accent',
  },
  {
    slug: 'mingxing-tafang',
    name: '明星塌房',
    description: '娱乐圈明星塌房现场直击，从顶流到老戏骨，不放过任何一个明星的翻车瞬间与争议事件。',
    icon: 'ri-vip-crown-line',
    color: 'primary',
  },
  {
    slug: 'bozhu-baoliao',
    name: '博主爆料',
    description: '知名博主匿名爆料合集，涵盖行业内幕、平台潜规则与各类独家揭秘内容，吃瓜第一线。',
    icon: 'ri-chat-smile-2-line',
    color: 'secondary',
  },
  {
    slug: 'zongyi-chigua',
    name: '综艺吃瓜',
    description: '热门综艺节目幕后故事、录制现场冲突、选手争议事件，让你一次吃够综艺圈的瓜。',
    icon: 'ri-tv-line',
    color: 'accent',
  },
  {
    slug: 'dianshi-juqing',
    name: '影视揭秘',
    description: '影视剧拍摄内幕、演员真实关系、片场花边新闻，揭开荧幕背后的真实面貌。',
    icon: 'ri-film-line',
    color: 'primary',
  },
];

export const categoryColorMap: Record<string, { bg: string; text: string; badge: string }> = {
  'wanghong-heliao': {
    bg: 'bg-accent-100',
    text: 'text-accent-800',
    badge: 'bg-accent-500',
  },
  'mingxing-tafang': {
    bg: 'bg-primary-100',
    text: 'text-primary-800',
    badge: 'bg-primary-500',
  },
  'bozhu-baoliao': {
    bg: 'bg-secondary-100',
    text: 'text-secondary-800',
    badge: 'bg-secondary-500',
  },
  'zongyi-chigua': {
    bg: 'bg-accent-100/70',
    text: 'text-accent-700',
    badge: 'bg-accent-500',
  },
  'dianshi-juqing': {
    bg: 'bg-primary-100/70',
    text: 'text-primary-700',
    badge: 'bg-primary-500',
  },
};